export const CY_INITIALIZED = 'cy-initialized';

export function dispatchInitialized() {
  if(process.env.NODE_ENV === 'testing') {
    console.log('cy-initialized');
  }
  document.dispatchEvent(new Event(CY_INITIALIZED));
}
